export const screeningSubmissionSuccessful = user => ({
  type: 'Submits Screening',
  data: {
    flow: 'weight_web_acquisition',
    email: user.email,
    user_id: user.id,
    submission_status: 'successful',
    reason: null,
  },
});

export const screeningSubmissionUnsuccessful = (user, error) => ({
  type: 'Submits Screening',
  data: {
    flow: 'weight_web_acquisition',
    email: user?.email,
    user_id: user?.id,
    submission_status: 'unsuccessful',
    reason: error,
  },
});
